import { render, staticRenderFns } from "./Tage.vue?vue&type=template&id=1435c726&"
import script from "./Tage.vue?vue&type=script&lang=js&"
export * from "./Tage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports